import Vue from 'vue';
import Router from 'vue-router';

import Root from '@/components/Root';

import Home from '@/components/app/home/Home';
import Perfil from '@/components/app/home/Perfil';
import Suporte from '@/components/app/home/Suporte';

import Login from '@/components/app/auth/Login';
import Logout from '@/components/app/auth/Logout';

// Compromissos
import Compromissos from '@/components/app/compromissos/Home';

import AmbientaisHome from '@/components/app/compromissos/ambientais/Home';
import AmbientaisForm from '@/components/app/compromissos/ambientais/Form';
import AmbientalCooperado from '@/components/app/compromissos/ambientais/AmbientalCooperado';

// Residuos
import Residuos from '@/components/app/residuos/Home';
import EmbalagensHome from '@/components/app/residuos/embalagens/Home';

import ColetaHome from '@/components/app/residuos/coleta/Home';
import ColetaForm from '@/components/app/residuos/coleta/Form';

// Renovacao
import Renovacao from '@/components/app/compromissos/renovacao/Home';

// Condicionantes
import Condicionantes from '@/components/app/compromissos/condicionantes/Home';

//ADMIN
import Admin from '@/components/app/admin/Home';

import EmpresasHome from '@/components/app/admin/empresas/Home';
import EmpresasForm from '@/components/app/admin/empresas/Form';

import PlanosHome from '@/components/app/admin/planos/Home';
import PlanosForm from '@/components/app/admin/planos/Form';

import UsuariosHome from '@/components/app/admin/usuarios/Home';
import UsuariosForm from '@/components/app/admin/usuarios/Form';


import EventosHome from '@/components/app/admin/eventos/Home';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: '/',
  linkExactActiveClass: 'active',
  routes: [{
      path: '/',
      component: Home,
      meta: {
        humanName: 'Menu',
        showOnNav: true
      }
    },
    {
      path: '/compromissos',
      redirect: '/compromissos/ambientais',
      component: Compromissos,
      meta: {
        humanName: 'Compromissos',
        showOnNav: false,
        alias: 'compromissos'
      },
      children: [
        {
          path: 'ambientais',
          component: AmbientaisHome,
          meta: {
            humanName: 'Ambientais'
          }
        },
        {
          path: 'ambientais/novo',
          component: AmbientaisForm,
          meta: {
            humanName: 'Novo'
          }
        },
        {
          path: 'ambientais/edit/:id',
          component: AmbientaisForm,
          meta: {
            humanName: 'Alterar'
          }
        },
        {
          path: 'ambientais/edit/:id/:acao',
          component: AmbientaisForm,
          meta: {
            humanName: 'Alterar'
          }
        },
        {
          path: 'ambientais/cooperado/:id',
          component: AmbientalCooperado,
          meta: {
            humanName: 'Ambientais - Cliente'
          }
        },
      ],
    },
    {
      path: '/renovacao',
      component: Renovacao,
      meta: {
        humanName: 'Renovação',
        showOnNav: false,
        alias: 'renovacao'
      }
    },
    {
      path: '/condicionantes',
      component: Condicionantes,
      meta: {
        humanName: 'Condicionantes',
        showOnNav: false,
        alias: 'condicionantes'
      }
    },
    {
      path: '/admin',
      redirect: '/admin/planos',
      component: Admin,
      meta: {
        humanName: 'Admin',
        showOnNav: false,
        onlyADM: false,
      },
      children: [{
          path: 'empresas',
          component: EmpresasHome,
          meta: {
            humanName: 'Empresas'
          }
        },
        {
          path: 'empresas/novo',
          component: EmpresasForm,
          meta: {
            humanName: 'Novo'
          }
        },
        {
          path: 'empresas/edit/:id',
          component: EmpresasForm,
          meta: {
            humanName: 'Edit'
          }
        },
        {
          path: 'planos',
          component: PlanosHome,
          meta: {
            humanName: 'Planos'
          }
        },
        {
          path: 'planos/novo',
          component: PlanosForm,
          meta: {
            humanName: 'Novo'
          }
        },
        {
          path: 'planos/edit/:id',
          component: PlanosForm,
          meta: {
            humanName: 'Edit'
          }
        },
        {
          path: 'usuarios',
          component: UsuariosHome,
          meta: {
            humanName: 'Usuários'
          }
        },
        {
          path: 'usuarios/novo',
          component: UsuariosForm,
          meta: {
            humanName: 'Novo'
          }
        },
        {
          path: 'usuarios/edit/:id',
          component: UsuariosForm,
          meta: {
            humanName: 'Edit'
          }
        },
        {
          path: 'eventos',
          component: EventosHome,
          meta: {
            humanName: 'Eventos'
          }
        },
      ],
    },
    {
      path: '/residuos',
      redirect: '/residuos/embalagens',
      component: Residuos,
      meta: {
        humanName: 'Resíduos',
        alias: 'residuos'
      },
      children: [{
          path: 'embalagens',
          component: EmbalagensHome,
          meta: {
            humanName: 'Embalagens'
          }
        },
        {
          path: 'coleta',
          component: ColetaHome,
          meta: {
            humanName: 'Coletas'
          }
        },
        {
          path: 'coleta/novo',
          component: ColetaForm,
          meta: {
            humanName: 'Novo'
          }
        },
      ],
    },
    {
      path: '/login',
      redirect: '/login/null',
      name: 'Login',
      component: Login,
      children: [{
        path: '/login/:token',
        component: Login,
      }]
    },
    {
      path: '/perfil',
      name: 'Perfil',
      component: Perfil
    },
    {
      path: '/suporte',
      name: 'Suporte',
      component: Suporte
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js